export const PHOTOGRAPHER_PACKAGE_LIST_VISIBLE_CATEGORY_PACKAGE = 'PHOTOGRAPHER_PACKAGE_LIST_VISIBLE_CATEGORY_PACKAGE';
